import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import Input from "../Input";
import Slider from "../Slider";
import { jobSelector } from "../../redux/selectors";
import { useMediaQuery } from "../../utils/hooks";
import "./styles.css";

const Form: FC<any> = (props) => {
  const { id, questions = [], handleChange, formData } = props;
  const { job } = useSelector(jobSelector);

  const largeDevice = useMediaQuery("(min-width:880px)");
  const mediumDevice = useMediaQuery("(min-width:672px)");

  const getWidth = () => {
    if (largeDevice) {
      return 700;
    } else if (mediumDevice) {
      return 550;
    }

    return 240;
  };

  const isFormValid = () => {
    let isValid = false;
    for (let i = 0; i < questions.length; i++) {
      isValid = false;
      const item = questions[i];

      if (formData[item.disableField]) {
        isValid = true;
        continue;
      }
      if (item.options && item.options.length > 0) {
        const fields = item.options.map((option: any) => {
          return option.fieldName;
        });
        if (formData[item.otherField] && !formData[item.otherFieldText]) {
          isValid = false;
          break;
        }
        if (formData[item.otherField] && formData[item.otherFieldText]) {
          isValid = true;
          continue;
        }
        for (let j = 0; j < fields.length; j++) {
          if (formData[fields[j]]) {
            isValid = true;
            break;
          }
        }
        if (item.hasSingleOption && formData[item.fieldName]) {
          isValid = true;
          continue;
        }
      }
      if (item.hasSlider) {
        isValid = true;
        continue;
      }
      if (!isValid) {
        break;
      }
    }
    return isValid;
  };

  useEffect(() => {
    for (let i = 0; i < questions.length; i++) {
      const item = questions[i];
      if (item.hasSlider) {
        const value = item.defaultRange;
        if (value[0] === value[1]) {
          formData[item.fieldName] = `${value[0]}${item.unit}`;
        } else {
          formData[
            item.fieldName
          ] = `${value[0]}${item.unit} - ${value[1]}${item.unit}`;
        }
      }
    }
    const isValid = isFormValid();
    handleChange({ ...formData, jobId: job.id }, isValid);
  }, [id]);

  const clickhandler = (target: any) => {
    formData[target.id] = target.checked;
    const isValid = isFormValid();
    handleChange(formData, isValid);
  };

  const changehandler = (key: string, value: string) => {
    formData[key] = value;
    const isValid = isFormValid();
    handleChange(formData, isValid);
  };

  const radioHandler = (target: any, item: any) => {
    formData[target.id] = target.value;
    formData[item.otherField] = false;
    formData[item.otherFieldText] = "";
    const isValid = isFormValid();
    handleChange(formData, isValid);
  };

  const disableHandler = (index: number, target: any) => {
    formData[target.id] = target.checked;
    if (target.checked) {
      if (!questions[index].hasSlider && !questions[index].hasSingleOption) {
        questions[index].options.forEach((option: any) => {
          formData[option.fieldName] = false;
        });
      }
      if (questions[index].hasSingleOption) {
        formData[questions[index].fieldName] = "";
      }
      if (questions[index].hasSlider) {
        const item = questions[index];
        const value = getRangeFromFormData(item);
        if (value[0] === value[1]) {
          formData[
            item.fieldName
          ] = `${value[0]}${item.unit} - ${value[0]}${item.unit}`;
        } else {
          formData[
            item.fieldName
          ] = `${value[0]}${item.unit} - ${value[1]}${item.unit}`;
        }
      }
      formData[questions[index].otherField] = false;
      formData[questions[index].otherFieldText] = "";
    }
    const isValid = isFormValid();
    handleChange(formData, isValid);
  };

  const otherHandler = (target: any, fieldText: string, fieldName: string) => {
    formData[target.id] = target.checked;
    if (!target.checked) {
      formData[fieldText] = "";
    } else {
      if (fieldName) {
        formData[fieldName] = "";
      }
    }
    const isValid = isFormValid();
    handleChange(formData, isValid);
  };

  const getRangeFromFormData = (item: any) => {
    if (formData[item.fieldName]) {
      const range = formData[item.fieldName];
      const updatedRange = range.replaceAll(item.unit, "");
      const startValue = updatedRange.split("-")[0].trim();
      const endValue = updatedRange.split("-")[1]
        ? updatedRange.split("-")[1].trim()
        : updatedRange.split("-")[0].trim();

      return [startValue, endValue];
    }

    return item.defaultRange;
  };

  const sliderHandler = (value: any, item: any) => {
    if (value[0] === value[1]) {
      formData[
        item.fieldName
      ] = `${value[0]}${item.unit} - ${value[0]}${item.unit}`;
    } else {
      formData[
        item.fieldName
      ] = `${value[0]}${item.unit} - ${value[1]}${item.unit}`;
    }
    const isValid = isFormValid();
    handleChange(formData, isValid);
  };

  return (
    <>
      {questions.map((item: any, index: number) => {
        return (
          <>
            <div className="form-question-title-container">
              <p
                className={`form-question ${
                  formData[item.disableField] ? "form-question-disabled" : ""
                }`}
              >
                {item.question}
              </p>
              <div className="form-check">
                <input
                  id={item.disableField}
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked={formData[item.disableField]}
                  onClick={(e) => {
                    disableHandler(index, e.target);
                  }}
                />
                <p
                  className="form-check-label"
                  style={{ color: "#ff0000", fontWeight: "bold" }}
                >
                  Disable
                </p>
              </div>
            </div>
            <div className="form-input-layout">
              {!item.hasSingleOption &&
                !item.hasSlider &&
                item.options.map((option: any) => {
                  return (
                    <div className="form-check">
                      <input
                        id={option.fieldName}
                        className="form-check-input"
                        type="checkbox"
                        checked={
                          formData[item.disableField]
                            ? false
                            : formData[option.fieldName]
                        }
                        onClick={(e) => {
                          clickhandler(e.target);
                        }}
                        disabled={formData[item.disableField]}
                      />
                      <p
                        className={`form-check-label ${
                          formData[item.disableField]
                            ? "form-check-label-disabled"
                            : ""
                        }`}
                      >
                        {option.name}
                      </p>
                    </div>
                  );
                })}
              {item.hasSingleOption &&
                !item.hasSlider &&
                item.options.map((option: any) => {
                  return (
                    <div className="form-check">
                      <input
                        id={item.fieldName}
                        className="form-check-input"
                        type="radio"
                        value={option.fieldName}
                        checked={formData[item.fieldName] === option.fieldName}
                        onClick={(e) => {
                          radioHandler(e.target, item);
                        }}
                        disabled={formData[item.disableField]}
                      />
                      <p
                        className={`form-check-label ${
                          formData[item.disableField]
                            ? "form-check-label-disabled"
                            : ""
                        }`}
                      >
                        {option.name}
                      </p>
                    </div>
                  );
                })}
              {!item.hasSlider && (
                <>
                  <div className="form-check">
                    <input
                      id={item.otherField}
                      className="form-check-input"
                      type="checkbox"
                      checked={
                        formData[item.disableField]
                          ? false
                          : formData[item.otherField]
                      }
                      onClick={(e) => {
                        otherHandler(
                          e.target,
                          item.otherFieldText,
                          item.fieldName
                        );
                      }}
                      disabled={formData[item.disableField]}
                    />
                    <p
                      className={`form-check-label ${
                        formData[item.disableField]
                          ? "form-check-label-disabled"
                          : ""
                      }`}
                    >
                      Other
                    </p>
                  </div>
                  <Input
                    className={
                      formData[item.otherField] &&
                      !formData[item.otherFieldText]
                        ? "form-text-input-error"
                        : ""
                    }
                    label=""
                    value={formData[item.otherFieldText]}
                    onChange={(event) => {
                      changehandler(item.otherFieldText, event?.target.value);
                    }}
                    onBlur={(event) => {
                      changehandler(item.otherFieldText, event?.target.value);
                    }}
                    disabled={!formData[item.otherField]}
                  />
                </>
              )}
              {item.hasSlider && (
                <div className="form-slider">
                  <Slider
                    marks={item.marks}
                    min={item.min}
                    max={item.max}
                    step={item.steps}
                    width={getWidth()}
                    sliderValue={getRangeFromFormData(item)}
                    onSliderChange={(value) => {
                      sliderHandler(value, item);
                    }}
                    disabled={formData[item.disableField]}
                  />
                </div>
              )}
            </div>
          </>
        );
      })}
    </>
  );
};

export default Form;
